import {
	// Get All Bookings

	BOOKING_LIST_DATA,
	BOOKING_LIST_FAILED,
	BOOKING_LIST_LOADING,

	// Get Booking Filter Data
	BOOKING_FILTER_DATA_VALUES,
	BOOKING_FILTER_DATA_FAILED,
	BOOKING_FILTER_DATA_LOADING,

	// Get Booking Detail
	GET_BOOKING_DETAIL_DATA_FAILED,
	GET_BOOKING_DETAIL_DATA_LOADING,
	GET_BOOKING_DETAIL_DATA_SUCCESS,

	//Get Booking Containers
	CONTAINERS_LIST_DATA,
	CONTAINERS_LIST_LOADING,
	CONTAINERS_LIST_FAILED,

	// Get Booking Document
	BOOKING_DOCUMENT_DATA,
	BOOKING_DOCUMENT_FAILED,
	BOOKING_DOCUMENT_LOADING
} from './actionTypes';

const initialState = {
	// Get filter condition
	filterCondition: {},
	filterConditionLoading: false,
	filterConditionError: false,

	// Get All Bookings
	bookings_data: [],
	bookings_data_loading: false,
	bookings_data_error: false,

	// Get Booking Filter Data
	booking_filter_data: [],
	booking_filter_data_loading: false,
	booking_filter_data_error: false,

	// Get Booking Details
	booking_detail_data: [],
	booking_detail_data_loading: false,
	booking_detail_data_error: false,

	// Get Booking Containers

	booking_containers_loading: false,
	booking_containers_error: false,
	booking_containers_data: [],

	// Get Booking Document
	booking_document_data: [],
	booking_document_loading: false,
	booking_document_error: false
};

const Bookings = (state = initialState, action) => {
	switch (action.type) {
		// Get All Bookings

		case BOOKING_LIST_LOADING:
			return {
				...state,
				bookings_data_loading: true
			};
		case BOOKING_LIST_DATA:
			return {
				...state,
				bookings_data_loading: false,
				bookings_data: action.payload
			};
		case BOOKING_LIST_FAILED:
			return { ...state, bookings_data_loading: false, bookings_data_error: true };
		// Get Booking Detail
		case GET_BOOKING_DETAIL_DATA_LOADING:
			return {
				...state,
				booking_detail_data_loading: true,
				booking_detail_data_error: false,
				booking_detail_data: []
			};
		case GET_BOOKING_DETAIL_DATA_SUCCESS:
			return {
				...state,
				booking_detail_data_loading: false,
				booking_detail_data: action.payload
			};
		case GET_BOOKING_DETAIL_DATA_FAILED:
			return { ...state, booking_detail_data_loading: false, booking_detail_data: [], booking_detail_data_error: true };
		case BOOKING_FILTER_DATA_VALUES:
			return {
				...state,
				booking_filter_data: action.payload,
				booking_filter_data_loading: false,
				booking_filter_data_error: false
			};
		case BOOKING_FILTER_DATA_LOADING:
			return {
				...state,
				booking_filter_data_loading: true
			};
		case BOOKING_FILTER_DATA_FAILED:
			return {
				...state,
				booking_filter_data_error: true
			};

		// Get Booking Containers
		case CONTAINERS_LIST_LOADING:
			return {
				...state,
				booking_containers_loading: true,
				booking_containers_error: false,
				booking_containers_data: []
			};
		case CONTAINERS_LIST_DATA:
			return {
				...state,
				booking_containers_loading: false,
				booking_containers_error: false,
				booking_containers_data: action.payload
			};
		case CONTAINERS_LIST_FAILED:
			return {
				...state,
				booking_containers_loading: false,
				booking_containers_error: true,
				booking_containers_data: []
			};

		// Get Booking Document
		case BOOKING_DOCUMENT_LOADING:
			return {
				...state,
				booking_document_loading: true,
				booking_document_error: false,
				booking_document_data: []
			};
		case BOOKING_DOCUMENT_DATA:
			return {
				...state,
				booking_document_loading: false,
				booking_document_error: false,
				booking_document_data: action.payload
			};
		case BOOKING_DOCUMENT_FAILED:
			return {
				...state,
				booking_document_loading: false,
				booking_document_error: true,
				booking_document_data: []
			};

		default:
			return { ...state };
	}
};

export default Bookings;
